<template lang="pug">
v-card(:max-width="availableContentWidth" flat :style="{'padding-right':'-16px'}")
	v-data-table(:items="snowheights" hide-default-footer :headers="headers" :mobile-breakpoint="0" must-sort :items-per-page="limit")
		template(#item="{item: snowheight}")
			tr
				td
					span.label.round(:class="snowheight.rankClass") {{snowheight.ranking}}
				td
					nuxt-link(:to="localePath({name: 'areas-area-snowheight', params: { area: snowheight.slug }})" :title="`Sneeuwhoogte ${snowheight.name}`")
						img.flag(:src="`https://static.wintersport.nl/images/flags/svg/${snowheight.country.countryCode}.svg`", :alt="snowheight.country.name")
						| {{snowheight.name}}
				td.text-right.text-md-left
					snowheight-bar(:max="maxSnowheight" :snowheight="snowheight.snowMountain")
				td
					snowheight-bar(:max="maxSnowheight" :snowheight="snowheight.snowValley")
				td.text-right(:class="zeroValueClass(snowheight.snowLast24)" :title="emptyTitle(snowheight.snowLast24)") {{prettySnowLast24(snowheight.snowLast24)}}
				td(:class="zeroValueClass(snowheight.lastSnowAt)" :title="emptyTitle(snowheight.lastSnowAt)") {{prettyLastSnowDate(snowheight.lastSnowAt)}}
				td
					v-sheet.label.text-center.font-weight-bold(dark :color="snowheight.slopeLengthOpen > 0 ? 'success' : 'error'" ) {{snowheight.slopeLengthOpen}}km
</template>

<style lang="sass">
.label.round
	font-size: 80%
	border-radius: 50%
	display: block
	width: 24px
	height: 24px
	text-align: center
	line-height: 24px
</style>

<script>
import dayjs from 'dayjs';
import SnowheightBar from '@/components/snowheight-bar.vue';

export default {
	components: {
		SnowheightBar
	},
	props: {
		limit: {
			type: Number,
			default: -1
		},
		snowheights: {
			type: Array,
			default() {
				return [];
			}
		},
		filter: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			today: dayjs(),
			pagination: {}
		};
	},
	computed: {
		availableContentWidth() {
			return this.$store.state.content_width.full;
		},
		headers() {
			return [
				{ text: '', value: 'ranking' },
				{
					text: this.$t('snowheight_table.head.name'),
					value: 'name'
				},
				{
					text: this.$t('snowheight_table.head.snow_mountain'),
					value: 'snowMountain'
				},
				{
					text: this.$t('snowheight_table.head.snow_valley'),
					value: 'snowValley'
				},
				{
					text: this.$t('snowheight_table.head.fresh_snow'),
					value: 'snowLast24',
					align: 'right'
				},
				{
					text: this.$t('snowheight_table.head.last_snow'),
					value: 'lastSnowAt'
				},
				{
					text: this.$t('snowheight_table.head.open_pistes'),
					value: 'slopeLengthOpen'
				}
			];
		},
		maxSnowheight() {
			return this.snowheights[0].snowMountain;
		}
	},
	methods: {
		prettyLastSnowDate(date) {
			if (date == null) return '-';
			const days = dayjs().diff(date, 'days');
			const months = dayjs().diff(date, 'months');

			if (days < 31) {
				return this.$tc('snowheight_table.days_ago', days, { days });
			} else if (days < 365) {
				return this.$tc('snowheight_table.months_ago', months, { months });
			} else {
				return dayjs(date).format('d-m-Y');
			}
		},
		prettySnowLast24(snow) {
			return snow == null ? '-' : snow + 'cm';
		},
		emptyTitle(data) {
			return data == null ? this.$t('snowheight_table.no_data') : '';
		},
		zeroValueClass(value) {
			if (value == null || value === 0) return 'grey--text';
		}
	}
};
</script>
